import script from "./checkTheProcess.vue?vue&type=script&setup=true&lang=ts"
export * from "./checkTheProcess.vue?vue&type=script&setup=true&lang=ts"

import "./checkTheProcess.vue?vue&type=style&index=0&id=12d30a9e&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d30a9e"]])

export default __exports__